var modules_3734c084 = {"wrapper":"_w3siel","wrapper--hidden":"_1v5m61g","overlay":"_1eapyn9","header":"_3vw9w"};
import "../../assets/C9cO3iWV.css";

export { modules_3734c084 as default };
//# sourceMappingURL=fullscreen-wrapper.module.scss.js.map
